<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">
      <!-- Grille des formations -->
      <div class="row">
          <div class="formation-card">
            <div class="formation-icon-wrapper">
              <i class="flaticon-education formation-icon"></i>
            </div>
            <div class="formation-content">
              <h5 class="formation-title">La Petite Voie de Sainte Thérèse de l'enfant Jésus</h5>
              <div class="formation-niveau">
                <i class="flaticon-level"></i>
                <span>En suivant l’exemple de Sainte Thérèse de Lisieux, la Petite Voie est un mouvement qui a pour vision d’imprimer une nouvelle civilisation de l’Amour au monde entier en contribuant à inverser l’individualisme et le manque d’amour observés dans le monde.
                    Être plus humain en aimant davantage le prochain comme soi-même et comme Dieu nous aime puis offrir des opportunités qui induisent le développement intégral.
                    Créer un réseau mondial de chrétiens vecteurs de paix et d’amour ; une Cité de Paix, d’Amour et de joie ; une communauté où chaque individu pourra mettre ses compétences à la disposition des autres.
                    Les actions de la Petite Voie sont portées par la prière individuelle et la pratique de la Lectio Divina.
                </span>
              </div>
            </div>
        </div>
      </div>
      <br><br><br>
    <div class="row ">
      <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
          <div class="blog-card style1">
              <div class="blog-img"  :style="{height:'277px', backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'}"
              >
              </div>
              <div class="blog-info" style="min-height: 250px;">
                  <ul class="blog-metainfo  list-style">
                      <li><i class="flaticon-user"></i> <router-link to="#">L' École d’Initiation Théologique et Pastorale</router-link></li>
                      <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication)  }}</li>
                  </ul>
                  <h3><router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">{{ article.titre }}</router-link></h3>
                  <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }" class="link style1">Lire plus
                      <i class="flaticon-right-arrow"></i>
                  </router-link>
              </div>
          </div>
      </div>
  </div> 
    </div>
  </div>
</template>

<script lang="ts">
  
import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
// import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'ActualitePoste',
  //   components: {
  //     PaginationComponent,

  // },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/30?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    
    onMounted(() => {
        getTreeArticle();
    });

    return { 
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});

</script>

<style scoped>
/* -------- SECTION -------- */
.service-wrap {
  background: #f4f6f9;
  padding: 70px 0;
}

.section-title {
  font-size: 2.4rem;
  font-weight: 800;
  color: #0b1b3f;
  margin-bottom: 15px;
  letter-spacing: -0.5px;
}

.section-subtitle {
  font-size: 1.05rem;
  color: #5c6168;
  max-width: 780px;
  margin: 0 auto 45px;
  line-height: 1.6;
}

/* -------- GRID -------- */
.row {
  display: flex;
  flex-wrap: wrap;
}

.col-xl-3, .col-lg-4, .col-md-6 {
  display: flex;
}

/* -------- GLASS CARD DESIGN -------- */
.formation-card {
  background: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 22px;
  border: 1px solid rgba(255, 193, 7, 0.2);
  padding: 35px 25px;
  box-shadow: 0 8px 28px rgba(11, 27, 63, 0.10);
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  transition: 0.35s ease;
  position: relative;
  overflow: hidden;
}

/* Hover */
.formation-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 18px 40px rgba(11, 27, 63, 0.22);
  border-color: rgba(255, 193, 7, 0.6);
}

/* Bande lumineuse animée */
.formation-card::before {
  content: "";
  position: absolute;
  top: -40%;
  left: -30%;
  width: 160%;
  height: 180%;
  background: radial-gradient(
    circle,
    rgba(255, 193, 7, 0.18) 0%,
    transparent 60%
  );
  transform: rotate(25deg);
  transition: opacity 0.5s ease;
  opacity: 0;
}

.formation-card:hover::before {
  opacity: 1;
}

/* -------- ICON -------- */
.formation-icon-wrapper {
  width: 82px;
  height: 82px;
  border-radius: 18px;
  background: rgba(11, 27, 63, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
  box-shadow: 0 0 12px rgba(255, 193, 7, 0.5);
  transition: 0.3s ease;
}

/* Hover */
.formation-card:hover .formation-icon-wrapper {
  box-shadow: 0 0 20px rgba(255, 193, 7, 0.8);
  transform: scale(1.05);
}

.formation-icon {
  font-size: 40px;
  color: #ffc107;
}

/* -------- TITRE -------- */
.formation-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 15px;
}

/* -------- DESCRIPTION -------- */
.formation-niveau {
  margin-top: auto;
  background: rgba(255, 255, 255, 0.35);
  border-left: 4px solid #ffc107;
  padding: 14px 18px;
  border-radius: 14px;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.formation-niveau i {
  font-size: 20px;
  color: #0b1b3f;
  opacity: 0.8;
  margin-right: 10px;
}

.formation-niveau span {
  font-size: 0.97rem;
  color: #1d1d1d;
  line-height: 1.55;
  font-weight: 500;
}

/* -------- RESPONSIVE -------- */
@media (max-width: 768px) {
  .formation-card {
    padding: 28px;
  }
  .formation-icon-wrapper {
    width: 70px;
    height: 70px;
  }
  .formation-icon {
    font-size: 34px;
  }
  .formation-title {
    font-size: 1.15rem;
  }
}

.col-xl-3, .col-lg-4, .col-md-6 {
  flex: 1 1 33.33%;
  max-width: 33.33%;
}

</style>